import Vue from "vue";
import Router from "vue-router";
import constantRouter from "./sync_router"; // 无权限要求路由
// import asyncRouter from "./async_router"; // 有权限要求的异步路由

Vue.use(Router);

export const constantRouterMap = [...constantRouter];
export const asyncRouterMap = [
  // ...asyncRouter,
  // {
  //   path: "*",
  //   redirect: "/404",
  //   hidden: true
  // }
];
// 解决路由重复点击跳转报错问题
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRouterMap.concat(asyncRouterMap)
  });
const router = createRouter();

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js